(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderHeightLive();

      window.addEventListener('resizeend', this.setHeaderHeight.bind(this));
      window.addEventListener('resizeend', this.setHeaderHeightLive.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => { this.preventHide = false; });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderHeightLive(event, zero) {
      document.documentElement.style.setProperty('--header-height-live', `${zero ? 0 : this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ig-interactive-listicle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ig-listicle')) {
    customElements.define('ig-listicle', class IgListicle extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.id_ = this.dataset.sectionId;
        this.design = this.dataset.design === 'true';
        this.useHistory = this.dataset.history === 'true' && !this.design && !!window.history.pushState;
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.segs = Array.from(this.querySelectorAll('[data-seg]'));
        this.fill = this.querySelector('[data-fill]');
        this.progress = this.querySelector('[data-progress]');
        this.currentEl = this.querySelector('[data-current]');
        this.editorKey = 'ig-listicle-editor-' + this.id_;
        this.index = 0;
        this.pushes = 0;
        this.picked = '';
        this.offerbar = this.querySelector('[data-offerbar]');
        this.obStart = parseInt(this.dataset.offerbarStart, 10) || 1;
        if (!this.steps.length) return;

        this._onClick = this.onClick.bind(this);
        this._onChange = this.onChange.bind(this);
        this._onInput = this.onInput.bind(this);
        this._onShow = () => this.querySelectorAll('.is-loading').forEach((b) => { b.classList.remove('is-loading'); b.disabled = false; });
        this.addEventListener('click', this._onClick);
        this.addEventListener('change', this._onChange);
        this.addEventListener('input', this._onInput);
        window.addEventListener('pageshow', this._onShow);

        this._onScroll = () => {
          if (this._dockRaf) return;
          this._dockRaf = requestAnimationFrame(() => { this._dockRaf = null; this.dock(); });
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll);
        if (window.ResizeObserver) {
          this._ro = new ResizeObserver(this._onScroll);
          this._ro.observe(this);
        }

        if (this.useHistory) {
          this._onPop = (e) => {
            const st = e.state;
            if (!st || st.igListicle !== this.id_) return;
            const i = Number(st.igStep) || 0;
            this.pushes += i > this.index ? 1 : -1;
            if (this.pushes < 0) this.pushes = 0;
            this.go(i, { fromHistory: true });
          };
          window.addEventListener('popstate', this._onPop);
        }

        if (this.design) {
          this._onSelect = (e) => {
            if (e.detail && e.detail.sectionId === this.id_) this.goToBlock(e.detail.blockId);
          };
          document.addEventListener('shopify:block:select', this._onSelect);
        }

        this.initDates();
        this.initTimer();
        this.initDrawers();
        this.initSwipe();
        this.querySelectorAll('[data-rev-track]').forEach((t) => {
          t.addEventListener('scroll', () => this.revArrows(t.closest('[data-revs]')), { passive: true });
        });

        let start = 0;
        if (this.design) {
          let saved = null;
          try { saved = sessionStorage.getItem(this.editorKey); } catch (err) {}
          const si = saved ? this.steps.findIndex((s) => s.dataset.blockId === saved) : -1;
          if (si > -1) start = si;
        } else if (this.useHistory) {
          const st = window.history.state;
          if (st && st.igListicle === this.id_) start = Number(st.igStep) || 0;
          this.replace(start);
        }
        this.go(start, { initial: true });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('change', this._onChange);
        this.removeEventListener('input', this._onInput);
        window.removeEventListener('pageshow', this._onShow);
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
        if (this._ro) this._ro.disconnect();
        if (this._dockRaf) cancelAnimationFrame(this._dockRaf);
        this._dockRaf = null;
        if (this._onPop) window.removeEventListener('popstate', this._onPop);
        if (this._onSelect) document.removeEventListener('shopify:block:select', this._onSelect);
        if (this.timerId) clearInterval(this.timerId);
        if (this._onClickCap) this.removeEventListener('click', this._onClickCap, true);
        if (this._onKey) window.removeEventListener('keydown', this._onKey);
        this.classList.remove('is-swiping');
        if (this._swTimer) clearTimeout(this._swTimer);
        (this.drawers || []).forEach((d) => { try { if (d.open) d.close(); } catch (err) {} });
        document.documentElement.classList.remove('ig-listicle-lock');
        this._ready = false;
      }

      /* ---------- Navigation ---------- */
      go(i, opts = {}) {
        i = Math.max(0, Math.min(i, this.steps.length - 1));
        const step = this.steps[i];
        const back = opts.back !== undefined ? opts.back : i < this.index;
        const changed = i !== this.index;
        this.index = i;
        if (changed && !opts.initial) this.hintGone();

        (this.drawers || []).forEach((d) => { if (d.open && !step.contains(d)) this.closeDrawer(d, true); });
        this.swipeReset();

        this.steps.forEach((s) => {
          if (s === step) return;
          s.hidden = true;
          s.classList.remove('is-entering', 'is-back');
          this.media(s, false);
        });
        step.hidden = false;
        this.media(step, true);
        this.warm(i + 1);

        if (!opts.initial) {
          step.classList.remove('is-entering', 'is-back');
          void step.offsetWidth;
          step.classList.add('is-entering');
          if (back) step.classList.add('is-back');
          if (!this.design) {
            const top = this.getBoundingClientRect().top;
            if (top < 0) window.scrollTo({ top: top + window.scrollY, behavior: 'instant' });
            const focus = step.querySelector('[data-step-focus]');
            if (focus) focus.focus({ preventScroll: true });
          }
          if (this.useHistory && !opts.fromHistory && changed) {
            window.history.pushState({ igListicle: this.id_, igStep: i }, '');
            this.pushes++;
          }
          if (changed) this.track(step, i);
        }

        if (this.design) {
          try { sessionStorage.setItem(this.editorKey, step.dataset.blockId); } catch (err) {}
          const pv = step.querySelector('[data-drawer][data-preview]');
          if (pv) this.openDrawer(pv);
        }
        step.querySelectorAll('[data-revs]').forEach((w) => this.revArrows(w));
        this.chrome();
        this.dock();
      }

      dock() {
        const step = this.steps[this.index];
        const slot = step ? step.querySelector('[data-bar-slot]') : null;
        if (!slot) return;
        const bar = slot.querySelector('[data-bar]');
        if (!bar) return;
        const h = bar.offsetHeight;
        if (slot._h !== h) { slot.style.minHeight = h + 'px'; slot._h = h; }
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const slotBottom = slot.getBoundingClientRect().bottom;
        const hostTop = this.getBoundingClientRect().top;
        const float = slotBottom > vh + 1 && hostTop < vh;
        bar.classList.toggle('is-floating', float);
      }

      next() { if (this.index < this.steps.length - 1) this.go(this.index + 1, { back: false }); }

      prev() {
        if (this.index <= 0) return;
        if (this.useHistory && this.pushes > 0) { window.history.back(); return; }
        this.go(this.index - 1, { back: true, fromHistory: true });
        if (this.useHistory) this.replace(this.index);
      }

      replace(i) {
        try { window.history.replaceState(Object.assign({}, window.history.state, { igListicle: this.id_, igStep: i }), ''); } catch (err) {}
      }

      goToBlock(id) {
        const i = this.steps.findIndex((s) => s.dataset.blockId === id);
        if (i < 0) return false;
        this.go(i);
        return true;
      }

      media(step, on) {
        const reduce = this.reduced();
        step.querySelectorAll('video').forEach((v) => {
          const gif = v.hasAttribute('data-gif');
          if (on && (v.hasAttribute('autoplay') || v.hasAttribute('data-autoplay')) && (gif || !reduce)) {
            this.vplay(v);
          } else if (!on) {
            v.pause();
          }
        });
      }

      /* Muted inline autoplay with retries: when data arrives, and on the first tap or scroll
         (iOS Low Power Mode and some in-app browsers only allow play after a gesture) */
      vplay(v) {
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        if (v.preload !== 'auto') v.preload = 'auto';
        const step = v.closest('[data-step]');
        const live = () => !step || !step.hidden;
        const go = () => {
          if (!live() || !v.paused) return;
          const p = v.play();
          if (p && p.catch) p.catch(() => this.vretry(v));
        };
        if (!v._igWired) {
          v._igWired = true;
          v.addEventListener('canplay', go);
          v.addEventListener('loadeddata', go);
        }
        if (v.readyState === 0) { try { v.load(); } catch (err) {} }
        go();
      }

      vretry(v) {
        if (this._vwait) { this._vwait.add(v); return; }
        this._vwait = new Set([v]);
        const kick = () => {
          const list = Array.from(this._vwait || []);
          this._vwait = null;
          ['touchstart', 'click', 'scroll', 'keydown'].forEach((t) => window.removeEventListener(t, kick, true));
          list.forEach((x) => { const st = x.closest('[data-step]'); if (!st || !st.hidden) { const p = x.play(); if (p && p.catch) p.catch(() => {}); } });
        };
        ['touchstart', 'click', 'scroll', 'keydown'].forEach((t) => window.addEventListener(t, kick, { capture: true, passive: true }));
      }

      reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

      /* Start loading the next step's images and videos so they are ready when it opens */
      warm(k) {
        const st = this.steps && this.steps[k];
        if (!st || st._warm) return;
        st._warm = true;
        st.querySelectorAll('img[loading="lazy"]').forEach((im) => { im.loading = 'eager'; });
        st.querySelectorAll('video[data-autoplay]').forEach((v) => {
          if (v.preload === 'auto') return;
          v.preload = 'auto';
          try { v.load(); } catch (err) {}
        });
      }

      chrome() {
        const total = this.steps.length;
        const cur = this.index + 1;
        this.segs.forEach((s, k) => s.classList.toggle('is-done', k < cur));
        if (this.fill) this.fill.style.transform = 'scaleX(' + (total ? cur / total : 0) + ')';
        if (this.progress) {
          this.progress.setAttribute('aria-valuenow', cur);
          this.progress.setAttribute('aria-valuetext', cur + ' / ' + total);
        }
        if (this.currentEl) {
          const pad = this.dataset.pad === 'true' && total < 100;
          this.currentEl.textContent = pad ? String(cur).padStart(2, '0') : String(cur);
        }
        this.dataset.step = cur;
        if (this.offerbar) this.offerbar.hidden = cur < this.obStart;
      }

      track(step, i) {
        if (this.design) return;
        const detail = { section: this.id_, step: i + 1, total: this.steps.length, block_id: step.dataset.blockId, type: step.dataset.type };
        this.dispatchEvent(new CustomEvent('tcc:listicle:step', { bubbles: true, detail: detail }));
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({ event: 'tcc_listicle_step', tcc_listicle: detail });
        }
      }

      /* ---------- Events ---------- */
      onClick(e) {
        if (e.target instanceof Element && e.target.closest('[data-pi-card],[data-pi-tier],[data-pi-switch],[data-pi-mode]') && this.piClick(e.target)) return;
        if (this.tapMedia(e)) return;
        const ph = e.target instanceof Element ? e.target.closest('[data-rev-photo]') : null;
        if (ph) { this.photoOpen(ph); return; }
        if (e.target instanceof Element && e.target.closest('[data-lightbox]')) { this.photoClose(); return; }
        const t = e.target instanceof Element
          ? e.target.closest('[data-next],[data-prev],[data-add],[data-tab],[data-drag-card],[data-rev],[data-drawer-open],[data-drawer-close],[data-offer-go]')
          : null;
        if (!t || t.disabled) return;
        if (t.hasAttribute('data-next')) this.next();
        else if (t.hasAttribute('data-prev')) this.prev();
        else if (t.hasAttribute('data-tab')) this.tabSet(t.closest('[data-tabs]'), t.dataset.tab);
        else if (t.hasAttribute('data-drag-card')) this.dragCard(t);
        else if (t.hasAttribute('data-rev')) this.revMove(t);
        else if (t.hasAttribute('data-drawer-open')) {
          const step = t.closest('[data-step]');
          const dr = step ? step.querySelector('[data-drawer]') : null;
          if (dr) { this._opener = t; this.openDrawer(dr); }
        } else if (t.hasAttribute('data-drawer-close')) this.closeDrawer(t.closest('[data-drawer]'));
        else if (t.hasAttribute('data-offer-go')) this.offerGo(t);
        else this.add(t);
      }

      onChange(e) {
        if (!(e.target instanceof Element)) return;
        const dev = e.target.closest('[data-device]');
        if (dev) { this.devChange(dev, e.target); return; }
        const sel = e.target.closest('[data-variant-select]');
        if (!sel) return;
        const o = sel.selectedOptions[0];
        const offer = sel.closest('[data-offer]');
        if (!o || !offer) return;
        const set = (q, val) => {
          const el = offer.querySelector(q);
          if (!el) return;
          el.textContent = val || '';
          el.hidden = !val;
        };
        set('[data-price]', o.dataset.price);
        set('[data-compare]', o.dataset.compare);
        set('[data-save]', o.dataset.save);
      }

      onInput(e) {
        const r = e.target instanceof Element ? e.target.closest('[data-drag-range]') : null;
        if (r) this.dragSet(r.closest('[data-drag]'), Number(r.value), true);
      }

      /* ---------- Swipe between steps ---------- */
      initSwipe() {
        if (this.dataset.swipe !== 'true') return;
        const body = this.querySelector('.ig-listicle__body');
        if (!body) return;
        this._sw = null;
        body.addEventListener('pointerdown', (e) => this.swipeStart(e), { passive: true });
        body.addEventListener('pointermove', (e) => this.swipeMove(e), { passive: true });
        body.addEventListener('pointerup', (e) => this.swipeEnd(e));
        body.addEventListener('pointercancel', (e) => { if (this._sw && this._sw.id === e.pointerId) this.swipeBack(); });
        body.addEventListener('lostpointercapture', (e) => { if (this._sw && this._sw.id === e.pointerId) this.swipeBack(); });
        body.addEventListener('dragstart', (e) => { if (e.target instanceof Element && e.target.closest('img, a')) e.preventDefault(); });
        body.addEventListener('wheel', (e) => this.swipeWheel(e), { passive: false });
        /* Touch: own handlers so a slightly diagonal thumb swipe still counts (Instagram-story feel).
           The first touchmove decides: mostly sideways = ours (page scroll is blocked for that gesture),
           mostly up/down = normal page scroll. */
        if ('ontouchstart' in window) {
          this._touch = true;
          body.addEventListener('touchstart', (e) => this.tStart(e), { passive: true });
          body.addEventListener('touchmove', (e) => this.tMove(e), { passive: false });
          body.addEventListener('touchend', (e) => this.tEnd(e), { passive: true });
          body.addEventListener('touchcancel', () => { if (this._sw && this._sw.id === 'touch') this.swipeBack(); }, { passive: true });
        }
        this.swipeHint();
        this._swBody = body;
        this._onKey = (e) => this.swipeKey(e);
        window.addEventListener('keydown', this._onKey);
        this._onClickCap = (e) => {
          if (!this._suppress) return;
          e.preventDefault();
          e.stopPropagation();
          this._suppress = false;
        };
        this.addEventListener('click', this._onClickCap, true);
      }

      swipeStart(e) {
        if (!e.isPrimary || this._swBusy) return;
        if (this._touch && e.pointerType === 'touch') return;
        const mouse = e.pointerType === 'mouse';
        if (mouse && e.button !== 0) return;
        const t = e.target instanceof Element ? e.target : null;
        if (!t || t.closest('video[controls]') || !this.swipeOk(t)) return;
        const vw = window.innerWidth || document.documentElement.clientWidth;
        if (!mouse && (e.clientX < 16 || e.clientX > vw - 16)) return;
        const step = this.steps[this.index];
        const box = step ? step.querySelector('.ig-listicle__container') : null;
        if (!box) return;
        this._sw = { id: e.pointerId, x: e.clientX, y: e.clientY, t: performance.now(), dx: 0, lock: '', edge: false, box: box, step: step, mouse: mouse };
      }

      swipeMove(e) {
        const s = this._sw;
        if (!s || e.pointerId !== s.id) return;
        const dx = e.clientX - s.x;
        const dy = e.clientY - s.y;
        if (!s.lock) {
          if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
          s.lock = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
          if (s.lock === 'y') { this._sw = null; return; }
          s.step.classList.remove('is-entering', 'is-back');
          s.box.style.transition = 'none';
          s.box.style.willChange = 'transform, opacity';
          if (s.mouse) {
            try { this._swBody.setPointerCapture(s.id); } catch (err) {}
            try { window.getSelection().removeAllRanges(); } catch (err) {}
            this.classList.add('is-swiping');
          }
        }
        s.edge = (dx < 0 && this.index >= this.steps.length - 1) || (dx > 0 && this.index <= 0);
        s.dx = dx;
        const d = s.edge ? dx * 0.25 : dx;
        const w = s.box.offsetWidth || 1;
        s.box.style.transform = 'translate3d(' + d + 'px, 0, 0)';
        s.box.style.opacity = String(1 - Math.min(Math.abs(d) / w, 1) * 0.6);
      }

      swipeEnd(e) {
        const s = this._sw;
        if (!s || e.pointerId !== s.id) return;
        this._sw = null;
        if (s.lock !== 'x') return;
        this.classList.remove('is-swiping');
        this._suppress = true;
        setTimeout(() => { this._suppress = false; }, 400);

        const w = s.box.offsetWidth || window.innerWidth;
        const dist = Math.abs(s.dx);
        const speed = dist / Math.max(performance.now() - s.t, 1);
        const pass = !s.edge && (dist > Math.min(70, w * 0.18) || (dist > 24 && speed > 0.25));
        if (!pass) { this.swipeBack(s); return; }

        this.swipeGo(s.dx < 0 ? 1 : -1, s.box);
      }

      tStart(e) {
        if (this._sw && this._sw.id === 'touch' && e.touches.length > 1) { this.swipeBack(); return; }
        if (this._swBusy || e.touches.length !== 1) return;
        const p = e.touches[0];
        const t = e.target instanceof Element ? e.target : null;
        if (!t || t.closest('video[controls]') || !this.swipeOk(t)) return;
        const vw = window.innerWidth || document.documentElement.clientWidth;
        if (p.clientX < 12 || p.clientX > vw - 12) return;
        const step = this.steps[this.index];
        const box = step ? step.querySelector('.ig-listicle__container') : null;
        if (!box) return;
        this._sw = { id: 'touch', x: p.clientX, y: p.clientY, t: performance.now(), dx: 0, lock: '', edge: false, box: box, step: step, mouse: false };
      }

      tMove(e) {
        const s = this._sw;
        if (!s || s.id !== 'touch') return;
        if (e.touches.length !== 1) { this.swipeBack(s); return; }
        const p = e.touches[0];
        const dx = p.clientX - s.x;
        const dy = p.clientY - s.y;
        if (!s.lock) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          if (!e.cancelable || Math.abs(dx) < Math.abs(dy) * 0.8) { this._sw = null; return; }
          s.lock = 'x';
          s.step.classList.remove('is-entering', 'is-back');
          s.box.style.transition = 'none';
          s.box.style.willChange = 'transform, opacity';
        }
        if (e.cancelable) e.preventDefault();
        s.edge = (dx < 0 && this.index >= this.steps.length - 1) || (dx > 0 && this.index <= 0);
        s.dx = dx;
        const d = s.edge ? dx * 0.25 : dx;
        const w = s.box.offsetWidth || 1;
        s.box.style.transform = 'translate3d(' + d + 'px, 0, 0)';
        s.box.style.opacity = String(1 - Math.min(Math.abs(d) / w, 1) * 0.6);
      }

      tEnd(e) {
        const s = this._sw;
        if (!s || s.id !== 'touch') return;
        const p = e.changedTouches && e.changedTouches[0];
        if (p && s.lock === 'x') s.dx = p.clientX - s.x;
        this.swipeEnd({ pointerId: 'touch' });
      }

      /* Tap an image like a story: left quarter = back, anywhere else = next */
      tapMedia(e) {
        if (this.dataset.tap !== 'true' || this._swBusy) return false;
        const t = e.target instanceof Element ? e.target : null;
        const cell = t ? t.closest('.ig-listicle__media-cell') : null;
        if (!cell || t.closest('a, button, video[controls], [data-drawer], [data-no-swipe], [data-rev-track]')) return false;
        const step = this.steps[this.index];
        if (!step || !step.contains(cell) || step.querySelector('[data-drawer]')) return false;
        const wrap = cell.closest('.ig-listicle__media') || cell;
        const r = wrap.getBoundingClientRect();
        const dir = (e.clientX - r.left) < r.width * 0.25 && this.index > 0 ? -1 : 1;
        if (dir > 0 && this.index >= this.steps.length - 1) return false;
        e.preventDefault();
        this.swipeGo(dir);
        return true;
      }

      /* Review photo: full-size view, closes on tap or Esc */
      photoOpen(btn) {
        let lb = this._lb;
        if (!lb) {
          lb = document.createElement('div');
          lb.className = 'ig-listicle__lightbox';
          lb.setAttribute('data-lightbox', '');
          lb.setAttribute('role', 'dialog');
          lb.setAttribute('aria-modal', 'true');
          lb.hidden = true;
          lb.innerHTML = '<button type="button" class="ig-listicle__lightbox-close" aria-label="Close"><svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 5l10 10M15 5L5 15"/></svg></button><img alt="">';
          this.appendChild(lb);
          this._lb = lb;
          this._igKey = (e) => { if (e.key === 'Escape') this.photoClose(); };
        }
        lb.querySelector('img').src = btn.dataset.revPhoto;
        lb.setAttribute('aria-label', btn.getAttribute('aria-label') || '');
        lb.hidden = false;
        this._igFrom = btn;
        document.documentElement.classList.add('ig-listicle-lock');
        window.addEventListener('keydown', this._igKey);
        lb.querySelector('button').focus({ preventScroll: true });
      }

      photoClose() {
        const lb = this._lb;
        if (!lb || lb.hidden) return;
        lb.hidden = true;
        window.removeEventListener('keydown', this._igKey);
        if (!(this.drawers || []).some((d) => d.open)) document.documentElement.classList.remove('ig-listicle-lock');
        if (this._igFrom) this._igFrom.focus({ preventScroll: true });
        this._igFrom = null;
      }

      /* One-time hint on the first image (touch screens only) */
      swipeHint() {
        const txt = (this.dataset.swipeHint || '').trim();
        if (!txt || this.design || !window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
        const step = this.steps[this.index];
        const cell = step ? step.querySelector('.ig-listicle__media-cell') : null;
        if (!cell || this.index >= this.steps.length - 1) return;
        const el = document.createElement('span');
        el.className = 'ig-listicle__hint';
        el.setAttribute('aria-hidden', 'true');
        el.textContent = txt;
        el.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 10h11M11 5l5 5-5 5"/></svg>');
        cell.appendChild(el);
        this._hint = el;
      }

      hintGone() {
        const el = this._hint;
        if (!el) return;
        this._hint = null;
        el.classList.add('is-gone');
        setTimeout(() => el.remove(), 320);
      }

      swipeGo(dir, box) {
        if (dir > 0 ? this.index >= this.steps.length - 1 : this.index <= 0) return;
        const step = this.steps[this.index];
        box = box || (step ? step.querySelector('.ig-listicle__container') : null);
        const from = this.index;
        const nav = () => {
          this._swBusy = false;
          if (dir > 0) this.next(); else this.prev();
          this._swTimer = setTimeout(() => { if (this.index === from) this.swipeReset(); }, 600);
        };
        if (!box || this.reduced()) { nav(); return; }
        const w = box.offsetWidth || window.innerWidth;
        this._swBusy = true;
        step.classList.remove('is-entering', 'is-back');
        box.style.transition = 'transform .18s ease-in, opacity .18s ease-in';
        box.style.transform = 'translate3d(' + (-dir * w * 0.6) + 'px, 0, 0)';
        box.style.opacity = '0';
        setTimeout(nav, 180);
      }

      swipeOk(t) {
        if (t instanceof Element && t.closest('input, select, textarea, [contenteditable], [data-rev-track], [data-drawer], [data-no-swipe]')) return false;
        return !(this.drawers || []).some((d) => d.open);
      }

      /* Trackpad two-finger swipe (horizontal wheel) */
      swipeWheel(e) {
        if (e.ctrlKey || Math.abs(e.deltaX) <= Math.abs(e.deltaY) || !this.swipeOk(e.target)) return;
        e.preventDefault();
        clearTimeout(this._wlT);
        this._wlT = setTimeout(() => { this._wLock = false; this._wx = 0; }, 180);
        if (this._wLock || this._swBusy) return;
        this._wx = (this._wx || 0) + e.deltaX;
        if (Math.abs(this._wx) < 60) return;
        const dir = this._wx > 0 ? 1 : -1;
        this._wx = 0;
        this._wLock = true;
        this.swipeGo(dir);
      }

      /* Left / right arrow keys while the listicle is on screen */
      swipeKey(e) {
        if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        const a = document.activeElement;
        if (a && a !== document.body && !this.contains(a)) return;
        if (a && (a.closest('[role="tablist"], [role="radiogroup"]') || !this.swipeOk(a))) return;
        const r = this.getBoundingClientRect();
        if (r.bottom <= 0 || r.top >= (window.innerHeight || 0)) return;
        if (this._swBusy) return;
        e.preventDefault();
        this.swipeGo(e.key === 'ArrowRight' ? 1 : -1);
      }

      swipeBack(s) {
        s = s || this._sw;
        this._sw = null;
        this.classList.remove('is-swiping');
        if (!s || s.lock !== 'x') return;
        const box = s.box;
        box.style.transition = 'transform .25s ease, opacity .25s ease';
        box.style.transform = '';
        box.style.opacity = '';
        setTimeout(() => { box.style.transition = ''; box.style.willChange = ''; }, 260);
      }

      swipeReset() {
        this.steps.forEach((st) => {
          const b = st.querySelector('.ig-listicle__container');
          if (!b) return;
          b.style.transition = '';
          b.style.transform = '';
          b.style.opacity = '';
          b.style.willChange = '';
        });
      }

      /* Bar product widget: jump to the offer step and open its drawer */
      offerGo(btn) {
        let i = this.steps.findIndex((s) => s.querySelector('[data-drawer]'));
        if (i < 0) i = this.steps.findIndex((s) => s.dataset.type === 'final');
        if (i < 0) i = this.steps.length - 1;
        const moved = i !== this.index;
        if (moved) this.go(i, { back: i < this.index });
        const dr = this.steps[i].querySelector('[data-drawer]');
        if (!dr) return;
        this._opener = moved ? null : btn;
        setTimeout(() => this.openDrawer(dr), moved && !this.reduced() ? 350 : 0);
      }

      /* ---------- Step Tabs ---------- */
      tabSet(tabs, n) {
        if (!tabs) return;
        tabs.querySelectorAll('[data-tab]').forEach((b) => {
          const on = b.dataset.tab === n;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        tabs.querySelectorAll('[data-tile]').forEach((t) => {
          t.classList.toggle('is-on', (t.dataset.on || '').split(',').indexOf(n) > -1);
        });
        tabs.querySelectorAll('[data-caption]').forEach((c) => { c.hidden = c.dataset.caption !== n; });
      }

      /* ---------- Step Drag ---------- */
      dragSet(drag, val, user) {
        if (!drag) return;
        const range = drag.querySelector('[data-drag-range]');
        if (!range) return;
        const min = Number(range.min) || 0;
        const max = Number(range.max) || 0;
        val = Math.min(Math.max(Math.round(val), min), max);
        range.value = val;
        range.style.setProperty('--p', (max > min ? ((val - min) / (max - min)) * 100 : 0) + '%');
        const unit = drag.dataset.unit || '';
        let label = val + (/^[A-Za-z]/.test(unit) ? ' ' : '') + unit;
        if (drag.dataset.clock === 'true') {
          const h = ((val % 24) + 24) % 24;
          label = (h % 12 === 0 ? 12 : h % 12) + ' ' + (h < 12 ? 'AM' : 'PM');
        }
        range.setAttribute('aria-valuetext', label);
        const out = drag.querySelector('[data-drag-value]');
        if (out) out.textContent = label;

        const cards = Array.from(drag.querySelectorAll('[data-drag-card]'));
        const card = cards.find((c) => c.dataset.max === '' || val <= Number(c.dataset.max)) || cards[cards.length - 1];
        cards.forEach((c) => {
          const on = c === card;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (!card) return;
        const n = parseInt(card.dataset.amount, 10) || 0;
        drag.querySelectorAll('[data-drag-icon]').forEach((ic, k) => { ic.hidden = k >= n; });
        const amt = drag.querySelector('[data-drag-amount]');
        if (amt) amt.textContent = n + ' ' + (n === 1 ? drag.dataset.one : drag.dataset.many);
        if (user) this.picked = card.dataset.name || '';
      }

      dragCard(card) {
        const drag = card.closest('[data-drag]');
        if (!drag) return;
        const range = drag.querySelector('[data-drag-range]');
        const cards = Array.from(drag.querySelectorAll('[data-drag-card]'));
        const k = cards.indexOf(card);
        let val;
        if (card.dataset.max !== '') val = Number(card.dataset.max);
        else if (k > 0 && cards[k - 1].dataset.max !== '') val = Number(cards[k - 1].dataset.max) + 1;
        else val = range ? Number(range.max) : 0;
        this.dragSet(drag, val, true);
      }

      /* ---------- Reviews slider ---------- */
      revMove(btn) {
        const wrap = btn.closest('[data-revs]');
        const track = wrap ? wrap.querySelector('[data-rev-track]') : null;
        if (!track) return;
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        track.scrollBy({ left: step * Number(btn.dataset.rev), behavior: this.reduced() ? 'auto' : 'smooth' });
      }

      revArrows(wrap) {
        if (!wrap) return;
        const track = wrap.querySelector('[data-rev-track]');
        const arrows = wrap.querySelector('[data-rev-arrows]');
        if (!track || !arrows) return;
        const max = track.scrollWidth - track.clientWidth;
        arrows.hidden = max <= 2;
        const [prev, next] = arrows.querySelectorAll('[data-rev]');
        const x = Math.abs(track.scrollLeft);
        if (prev) prev.disabled = x <= 2;
        if (next) next.disabled = x >= max - 2;
      }

      /* ---------- Offer drawer: size cards + subscribe / buy once ---------- */
      initDrawers() {
        this.drawers = Array.from(this.querySelectorAll('[data-drawer]'));
        this.drawers.forEach((d) => {
          d.addEventListener('cancel', (e) => { e.preventDefault(); this.closeDrawer(d); });
          d.addEventListener('click', (e) => { if (e.target === d) this.closeDrawer(d); });
          const cards = Array.from(d.querySelectorAll('[data-pi-card]'));
          const act = cards.findIndex((c) => c.classList.contains('is-active'));
          d._i = act > -1 ? act : 0;
          const tiers = Array.from(d.querySelectorAll('[data-pi-tier]'));
          const ta = tiers.findIndex((b) => b.classList.contains('is-active'));
          d._t = ta > -1 ? ta : 0;
          d._wantSub = d.dataset.defaultSub === 'true';
          this.piRender(d);
        });
      }

      piClick(t) {
        const dr = t.closest('[data-drawer]');
        if (!dr) return false;
        const tier = t.closest('[data-pi-tier]');
        if (tier) {
          dr._t = Array.from(dr.querySelectorAll('[data-pi-tier]')).indexOf(tier);
          this.piRender(dr);
          return true;
        }
        const card = t.closest('[data-pi-card]');
        if (card) {
          if (card.disabled) return true;
          dr._i = Array.from(dr.querySelectorAll('[data-pi-card]')).indexOf(card);
          this.piRender(dr);
          return true;
        }
        const sw = dr.querySelector('[data-pi-switch]');
        const canToggle = sw && !sw.disabled;
        if (t.closest('[data-pi-switch]')) {
          if (canToggle) { dr._wantSub = !dr._sub; this.piRender(dr); }
          return true;
        }
        const mode = t.closest('[data-pi-mode]');
        if (mode) {
          if (canToggle) { dr._wantSub = mode.dataset.piMode === 'sub'; this.piRender(dr); }
          return true;
        }
        return false;
      }

      piRender(dr) {
        const cards = Array.from(dr.querySelectorAll('[data-pi-card]'));
        const i = dr._i || 0;
        cards.forEach((c, k) => {
          const on = k === i;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        dr.querySelectorAll('[data-pi-panel]').forEach((p) => { p.hidden = Number(p.dataset.piPanel) !== i; });

        const card = cards[i];
        const atc = dr.querySelector('[data-drawer-atc]');
        if (!card) {
          /* Single product without size cards: keep the server-rendered state, only sync the toggle */
          this.piMode(dr, dr.dataset.plan || '', atc);
          this.piTier(dr);
          return;
        }
        const plan = card.dataset.planId || '';
        this.piMode(dr, plan, atc);
        dr.querySelectorAll('[data-pi-percent]').forEach((el) => { el.textContent = card.dataset.percent || '0'; });
        dr.querySelectorAll('[data-pi-after-percent]').forEach((el) => { el.textContent = card.dataset.afterPercent || '0'; });
        if (atc) {
          const ok = !!card.dataset.variantId && card.dataset.available === 'true';
          atc.dataset.variant = ok ? card.dataset.variantId : '';
          atc.disabled = !ok;
          atc.dataset.plan = dr._sub ? plan : '';
        }
        this.piTier(dr);
        const err = dr.querySelector('[data-error]');
        if (err) err.hidden = true;
      }

      /* Bundle tiers: quantity, discount code, gift and the price shown on the add-to-cart button */
      piTier(dr) {
        const tiers = Array.from(dr.querySelectorAll('[data-pi-tier]'));
        if (!tiers.length) return;
        const k = Math.max(0, Math.min(dr._t || 0, tiers.length - 1));
        dr._t = k;
        tiers.forEach((b, j) => {
          const on = j === k;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        const tier = tiers[k];
        const atc = dr.querySelector('[data-drawer-atc]');
        if (!atc) return;
        atc.dataset.qty = tier.dataset.qty || '1';
        const pn = dr.querySelector('[data-pi-pack-name]');
        if (pn) pn.textContent = tier.dataset.name || '';
        const pp = dr.querySelector('[data-pi-pack-price]');
        if (pp) pp.textContent = tier.dataset.price || '';
        const pc = dr.querySelector('[data-pi-pack-compare]');
        if (pc) { pc.textContent = tier.dataset.compare || ''; pc.hidden = !tier.dataset.compare; }
        const devs = dr.querySelector('[data-devices]');
        if (devs) {
          const q = Math.max(1, parseInt(atc.dataset.qty, 10) || 1);
          devs.querySelectorAll('[data-device]').forEach((r) => {
            r.hidden = Number(r.dataset.device) > q;
            if (r.hidden) this.devError(r, '');
          });
        }
        atc.dataset.code = tier.dataset.code || '';
        atc.dataset.gift = tier.dataset.gift || '';
        atc.dataset.kbar = tier.dataset.kbar || '';
        atc.dataset.kgift = tier.dataset.kgift || '';
        const ok = !atc.disabled;
        const lbl = atc.querySelector('[data-pi-atc-label]');
        if (lbl) lbl.textContent = ok ? (lbl.dataset.label || '') : (lbl.dataset.soldout || '');
        const tail = atc.querySelector('[data-pi-atc-tail]');
        if (tail) tail.hidden = !ok;
        const pr = atc.querySelector('[data-pi-atc-price]');
        if (pr) pr.textContent = tier.dataset.price || '';
        const cp = atc.querySelector('[data-pi-atc-compare]');
        if (cp) {
          cp.textContent = tier.dataset.compare || '';
          cp.hidden = !tier.dataset.compare;
        }
      }

      piMode(dr, plan, atc) {
        const hasPlan = plan !== '';
        const requires = dr.dataset.requiresPlan === 'true';
        dr._sub = hasPlan && (requires || dr._wantSub);
        dr.classList.toggle('ig-listicle__pi--sub', dr._sub);
        dr.classList.toggle('ig-listicle__pi--once', !dr._sub);
        dr.classList.toggle('ig-listicle__pi--no-plan', !hasPlan);
        const sw = dr.querySelector('[data-pi-switch]');
        if (sw) {
          sw.setAttribute('aria-checked', String(dr._sub));
          sw.disabled = !hasPlan || requires;
        }
        if (atc) atc.dataset.plan = dr._sub ? plan : '';
      }

      piPick(dr, name) {
        const want = String(name || '').trim().toLowerCase();
        if (!want) return;
        const cards = Array.from(dr.querySelectorAll('[data-pi-card]'));
        const k = cards.findIndex((c) => {
          const n = (c.dataset.name || '').trim().toLowerCase();
          return n === want || n.indexOf(want + ' ') === 0 || want.indexOf(n + ' ') === 0;
        });
        if (k > -1 && !cards[k].disabled) { dr._i = k; this.piRender(dr); return; }
        const tiers = Array.from(dr.querySelectorAll('[data-pi-tier]'));
        const t = tiers.findIndex((b) => (b.dataset.name || '').trim().toLowerCase() === want);
        if (t > -1) { dr._t = t; this.piRender(dr); }
      }

      openDrawer(dr) {
        if (!dr || dr.open) return;
        if (this.picked && dr._picked !== this.picked) {
          dr._picked = this.picked;
          this.piPick(dr, this.picked);
        }
        this._lastFocus = this._opener || document.activeElement;
        this._opener = null;
        try { dr.showModal(); } catch (err) { dr.setAttribute('open', ''); }
        document.documentElement.classList.add('ig-listicle-lock');
        requestAnimationFrame(() => requestAnimationFrame(() => dr.classList.add('is-open')));
        if (!this.design) this.dispatchEvent(new CustomEvent('tcc:listicle:drawer', { bubbles: true, detail: { section: this.id_, open: true } }));
      }

      closeDrawer(dr, instant) {
        if (!dr || !dr.open) return;
        dr.classList.remove('is-open');
        const done = () => {
          try { dr.close(); } catch (err) { dr.removeAttribute('open'); }
          if (!(this.drawers || []).some((d) => d.open)) document.documentElement.classList.remove('ig-listicle-lock');
          const f = this._lastFocus;
          this._lastFocus = null;
          if (!instant && f && typeof f.focus === 'function' && this.contains(f)) f.focus({ preventScroll: true });
        };
        if (instant || this.reduced()) done();
        else setTimeout(done, 320);
      }

      /* ---------- Cart ---------- */
      async add(btn) {
        const step = btn.closest('[data-step]');
        const dr = btn.closest('[data-drawer]');
        const devs = dr && btn.hasAttribute('data-drawer-atc') ? dr.querySelector('[data-devices]') : null;
        let lines;
        if (devs) {
          /* One cart line per phone model + style; same phone twice = quantity 2 */
          lines = this.devItems(dr, devs);
          if (!lines) return;
        } else {
          let id = btn.dataset.variant;
          if (btn.hasAttribute('data-use-select') && step) {
            const sel = step.querySelector('[data-variant-select]');
            if (sel && sel.value) id = sel.value;
          }
          if (!id) return;
          const it = { id: Number(id), quantity: Math.max(1, parseInt(btn.dataset.qty, 10) || 1) };
          if (btn.dataset.plan) it.selling_plan = Number(btn.dataset.plan);
          lines = [it];
        }
        const scope = dr || btn.closest('[data-offer]') || btn.closest('[data-bar]') || step;
        const err = (scope && scope.querySelector('[data-error]')) || (step && step.querySelector('[data-error]'));
        btn.disabled = true;
        btn.classList.add('is-loading');
        if (err) err.hidden = true;
        try {
          const root = (this.dataset.root || '/').replace(/\/$/, '');
          /* Direct checkout: empty the cart first so a back-button retry never doubles the bundle */
          if (btn.hasAttribute('data-replace')) {
            await fetch(root + '/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
          }
          const list = lines.slice();
          const gift = Number(String(btn.dataset.gift || '').trim());
          /* Kaching Bundles: the same line properties its own widget sends, so its discount prices the
             bundle and makes the gift free. Every phone line in the bundle carries the same group id. */
          const deal = dr ? (dr.dataset.kdeal || '').trim() : '';
          const ver = dr ? (dr.dataset.kver || '').trim() : '';
          let group = '';
          if (deal) {
            const abc = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            for (let n = 0; n < 4; n++) group += abc[Math.floor(Math.random() * abc.length)];
            const main = { deal: deal, pp: Number(dr.dataset.productId) || undefined, main: true, id: group };
            if (ver) main.v = ver;
            if ((btn.dataset.kbar || '').trim()) main.bid = btn.dataset.kbar.trim();
            list.forEach((it) => { it.properties = { __kaching_bundles: JSON.stringify(main) }; });
          }
          if (gift > 0) {
            const g = { id: gift, quantity: 1 };
            const kg = (btn.dataset.kgift || '').trim();
            if (deal && kg) {
              const gp = { id: group, deal: deal, gift: kg };
              if (ver) gp.v = ver;
              g.properties = { __kaching_bundles: JSON.stringify(gp) };
            }
            list.push(g);
          }
          const r = await fetch(this.dataset.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: list })
          });
          if (!r.ok) throw new Error('add');
          let target = btn.dataset.action === 'checkout' ? root + '/checkout' : this.dataset.cartUrl;
          const code = (btn.dataset.code || '').trim() || (step ? (step.dataset.discount || '').trim() : '');
          if (code) target = root + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target);
          window.location.href = target;
        } catch (e) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          if (err) err.hidden = false;
          this.dock();
        }
      }

      /* ---------- Phone pickers: one model + style per phone in the pack ---------- */
      devItems(dr, devs) {
        if (!dr._variants) {
          const src = dr.querySelector('[data-pi-variants]');
          try { dr._variants = JSON.parse(src ? src.textContent : '[]'); } catch (err) { dr._variants = []; }
        }
        const variants = dr._variants;
        const mi = parseInt(devs.dataset.modelIndex, 10) || 0;
        const si = parseInt(devs.dataset.styleIndex, 10);
        const lines = [];
        let first = null;
        Array.from(devs.querySelectorAll('[data-device]')).filter((r) => !r.hidden).forEach((r) => {
          const sel = r.querySelector('[data-device-model]');
          const st = r.querySelector('input[data-device-style]:checked') || r.querySelector('select[data-device-style]');
          const model = sel ? sel.value : '';
          const style = st ? st.value : '';
          let msg = '';
          let v = null;
          if (!model) {
            msg = devs.dataset.msgModel || 'Choose a model';
          } else {
            v = variants.find((x) => x.o[mi] === model && (!(si >= 0) || !style || x.o[si] === style)) || null;
            if (!v) msg = devs.dataset.msgMissing || 'Not available';
            else if (!v.a) msg = devs.dataset.msgSoldout || 'Sold out';
          }
          this.devError(r, msg);
          if (msg) { if (!first) first = sel || r; return; }
          lines.push({ id: Number(v.id), quantity: 1 });
        });
        if (first) {
          if (typeof first.focus === 'function') first.focus();
          if (typeof first.scrollIntoView === 'function') first.scrollIntoView({ block: 'center', behavior: this.reduced() ? 'auto' : 'smooth' });
          return null;
        }
        return lines.length ? lines : null;
      }

      devError(row, msg) {
        const el = row.querySelector('[data-device-error]');
        const sel = row.querySelector('[data-device-model]');
        row.classList.toggle('is-invalid', !!msg);
        if (sel) {
          if (msg) sel.setAttribute('aria-invalid', 'true');
          else sel.removeAttribute('aria-invalid');
        }
        if (el) { el.textContent = msg || ''; el.hidden = !msg; }
      }

      /* Picking phone 1 pre-fills the other empty rows with the same model (still editable) */
      devChange(row, target) {
        this.devError(row, '');
        const devs = row.closest('[data-devices]');
        if (!devs || !target.matches('[data-device-model]') || row.dataset.device !== '1' || !target.value) return;
        devs.querySelectorAll('[data-device]').forEach((r) => {
          if (r === row) return;
          const s = r.querySelector('[data-device-model]');
          if (s && !s.value) s.value = target.value;
        });
      }

      /* ---------- Date + timer ---------- */
      initDates() {
        const lang = document.documentElement.lang || undefined;
        let today = '';
        try { today = new Date().toLocaleDateString(lang, { year: 'numeric', month: 'long', day: 'numeric' }); } catch (err) { return; }
        this.querySelectorAll('[data-date]').forEach((el) => {
          el.textContent = el.dataset.date.replace(/\{today\}/g, today);
        });
      }

      initTimer() {
        const els = Array.from(this.querySelectorAll('[data-timer-value]'));
        if (!els.length) return;
        const dur = Math.max(1, parseFloat(this.dataset.timerMinutes) || 15) * 60000;
        const restart = this.dataset.timerRestart === 'true';
        const key = 'ig-listicle-timer-' + this.id_;
        const save = (v) => { try { sessionStorage.setItem(key, String(v)); } catch (err) {} };
        let end = 0;
        try { end = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (err) {}
        if (!end || (end <= Date.now() && restart)) { end = Date.now() + dur; save(end); }
        const two = (n) => String(n).padStart(2, '0');
        const tick = () => {
          let left = end - Date.now();
          if (left <= 0) {
            if (restart) { end = Date.now() + dur; save(end); left = dur; }
            else left = 0;
          }
          const sec = Math.ceil(left / 1000);
          const h = Math.floor(sec / 3600);
          const m = Math.floor((sec % 3600) / 60);
          const sc = sec % 60;
          const txt = two(h) + ':' + two(m) + ':' + two(sc);
          const lbl = two(h) + 'h : ' + two(m) + 'm : ' + two(sc) + 's';
          els.forEach((el) => { el.textContent = el.dataset.format === 'labels' ? lbl : txt; });
          if (!left && this.timerId) clearInterval(this.timerId);
        };
        tick();
        this.timerId = setInterval(tick, 1000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-advertorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcc-adv-tally')) {
    customElements.define('tcc-adv-tally', class extends HTMLElement {
      connectedCallback() {
        this.onChange = (event) => {
          if (event.target.matches('[data-tcc-moment]')) this.update();
        };
        this.addEventListener('change', this.onChange);
        this.update();
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }
      update() {
        const count = Array.from(this.querySelectorAll('[data-tcc-moment]')).filter((box) => box.checked).length;
        this.querySelectorAll('[data-tcc-count]').forEach((el) => { el.textContent = count; });
        this.querySelectorAll('[data-tcc-when]').forEach((el) => {
          el.hidden = el.dataset.tccWhen === 'any' ? count === 0 : count > 0;
        });
      }
    });
  }

  if (!customElements.get('tcc-adv-sticky')) {
    customElements.define('tcc-adv-sticky', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.tcc-adv');
        this.trigger = this.root.querySelector('[data-tcc-sticky-after]');
        this.hideWhen = Array.from(this.root.querySelectorAll('[data-tcc-sticky-hide]'));
        this.forced = false;
        this.ticking = false;
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => { this.ticking = false; this.update(); });
        };
        // Theme Editor: show the bar only while its own block is selected.
        this.onSelect = (event) => { this.forced = !!(event.detail && event.detail.blockId === this.dataset.blockId); this.update(); };
        this.onDeselect = () => { this.forced = false; this.update(); };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);
        document.addEventListener('shopify:section:deselect', this.onDeselect);
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('shopify:block:select', this.onSelect);
        document.removeEventListener('shopify:block:deselect', this.onDeselect);
        document.removeEventListener('shopify:section:deselect', this.onDeselect);
      }
      update() {
        // Visible only once the block above the Sticky button block has scrolled past the top of the screen.
        // No block above it means no trigger, so the bar stays hidden.
        const passed = !!this.trigger && this.trigger.getBoundingClientRect().bottom < 0;
        // Step aside while a button marked "Hide sticky button while this button is on screen" is visible.
        const vh = window.innerHeight;
        const covered = this.hideWhen.some((el) => {
          const r = el.getBoundingClientRect();
          return r.width > 0 && r.bottom > 0 && r.top < vh;
        });
        const show = this.forced || (passed && !covered);
        this.classList.toggle('is-visible', show);
        this.inert = !show;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-interactive-listicle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcc-listicle')) {
    customElements.define('tcc-listicle', class TccListicle extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.id_ = this.dataset.sectionId;
        this.design = this.dataset.design === 'true';
        this.useHistory = this.dataset.history === 'true' && !this.design && !!window.history.pushState;
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.segs = Array.from(this.querySelectorAll('[data-seg]'));
        this.fill = this.querySelector('[data-fill]');
        this.progress = this.querySelector('[data-progress]');
        this.currentEl = this.querySelector('[data-current]');
        this.editorKey = 'tcc-listicle-editor-' + this.id_;
        this.index = 0;
        this.pushes = 0;
        if (!this.steps.length) return;

        this._onClick = this.onClick.bind(this);
        this._onChange = this.onChange.bind(this);
        this._onShow = () => this.querySelectorAll('.is-loading').forEach((b) => { b.classList.remove('is-loading'); b.disabled = false; });
        this.addEventListener('click', this._onClick);
        this.addEventListener('change', this._onChange);
        window.addEventListener('pageshow', this._onShow);

        this._onScroll = () => {
          if (this._dockRaf) return;
          this._dockRaf = requestAnimationFrame(() => { this._dockRaf = null; this.dock(); });
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll);
        if (window.ResizeObserver) {
          this._ro = new ResizeObserver(this._onScroll);
          this._ro.observe(this);
        }

        if (this.useHistory) {
          this._onPop = (e) => {
            const st = e.state;
            if (!st || st.tccListicle !== this.id_) return;
            const i = Number(st.tccStep) || 0;
            this.pushes += i > this.index ? 1 : -1;
            if (this.pushes < 0) this.pushes = 0;
            this.go(i, { fromHistory: true });
          };
          window.addEventListener('popstate', this._onPop);
        }

        if (this.design) {
          this._onSelect = (e) => {
            if (e.detail && e.detail.sectionId === this.id_) this.goToBlock(e.detail.blockId);
          };
          document.addEventListener('shopify:block:select', this._onSelect);
        }

        this.initDates();
        this.initTimer();

        let start = 0;
        if (this.design) {
          let saved = null;
          try { saved = sessionStorage.getItem(this.editorKey); } catch (err) {}
          const si = saved ? this.steps.findIndex((s) => s.dataset.blockId === saved) : -1;
          if (si > -1) start = si;
        } else if (this.useHistory) {
          const st = window.history.state;
          if (st && st.tccListicle === this.id_) start = Number(st.tccStep) || 0;
          this.replace(start);
        }
        this.go(start, { initial: true });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('change', this._onChange);
        window.removeEventListener('pageshow', this._onShow);
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
        if (this._ro) this._ro.disconnect();
        if (this._dockRaf) cancelAnimationFrame(this._dockRaf);
        this._dockRaf = null;
        if (this._onPop) window.removeEventListener('popstate', this._onPop);
        if (this._onSelect) document.removeEventListener('shopify:block:select', this._onSelect);
        if (this.timerId) clearInterval(this.timerId);
        this._ready = false;
      }

      /* ---------- Navigation ---------- */
      go(i, opts = {}) {
        i = Math.max(0, Math.min(i, this.steps.length - 1));
        const step = this.steps[i];
        const back = opts.back !== undefined ? opts.back : i < this.index;
        const changed = i !== this.index;
        this.index = i;

        this.steps.forEach((s) => {
          if (s === step) return;
          s.hidden = true;
          s.classList.remove('is-entering', 'is-back');
          this.media(s, false);
        });
        step.hidden = false;
        this.media(step, true);

        if (!opts.initial) {
          step.classList.remove('is-entering', 'is-back');
          void step.offsetWidth;
          step.classList.add('is-entering');
          if (back) step.classList.add('is-back');
          if (!this.design) {
            const top = this.getBoundingClientRect().top;
            if (top < 0) window.scrollTo({ top: top + window.scrollY, behavior: 'instant' });
            const focus = step.querySelector('[data-step-focus]');
            if (focus) focus.focus({ preventScroll: true });
          }
          if (this.useHistory && !opts.fromHistory && changed) {
            window.history.pushState({ tccListicle: this.id_, tccStep: i }, '');
            this.pushes++;
          }
          if (changed) this.track(step, i);
        }

        if (this.design) {
          try { sessionStorage.setItem(this.editorKey, step.dataset.blockId); } catch (err) {}
        }
        this.chrome();
        this.dock();
      }

      dock() {
        const step = this.steps[this.index];
        const slot = step ? step.querySelector('[data-bar-slot]') : null;
        if (!slot) return;
        const bar = slot.querySelector('[data-bar]');
        if (!bar) return;
        const h = bar.offsetHeight;
        if (slot._h !== h) { slot.style.minHeight = h + 'px'; slot._h = h; }
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const slotBottom = slot.getBoundingClientRect().bottom;
        const hostTop = this.getBoundingClientRect().top;
        const float = slotBottom > vh + 1 && hostTop < vh;
        bar.classList.toggle('is-floating', float);
      }

      next() { if (this.index < this.steps.length - 1) this.go(this.index + 1, { back: false }); }

      prev() {
        if (this.index <= 0) return;
        if (this.useHistory && this.pushes > 0) { window.history.back(); return; }
        this.go(this.index - 1, { back: true, fromHistory: true });
        if (this.useHistory) this.replace(this.index);
      }

      replace(i) {
        try { window.history.replaceState(Object.assign({}, window.history.state, { tccListicle: this.id_, tccStep: i }), ''); } catch (err) {}
      }

      goToBlock(id) {
        const i = this.steps.findIndex((s) => s.dataset.blockId === id);
        if (i < 0) return false;
        this.go(i);
        return true;
      }

      media(step, on) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        step.querySelectorAll('video').forEach((v) => {
          if (on && v.hasAttribute('autoplay') && !reduce) {
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          } else if (!on) {
            v.pause();
          }
        });
      }

      chrome() {
        const total = this.steps.length;
        const cur = this.index + 1;
        this.segs.forEach((s, k) => s.classList.toggle('is-done', k < cur));
        if (this.fill) this.fill.style.transform = 'scaleX(' + (total ? cur / total : 0) + ')';
        if (this.progress) {
          this.progress.setAttribute('aria-valuenow', cur);
          this.progress.setAttribute('aria-valuetext', cur + ' / ' + total);
        }
        if (this.currentEl) {
          const pad = this.dataset.pad === 'true' && total < 100;
          this.currentEl.textContent = pad ? String(cur).padStart(2, '0') : String(cur);
        }
        this.dataset.step = cur;
      }

      track(step, i) {
        if (this.design) return;
        const detail = { section: this.id_, step: i + 1, total: this.steps.length, block_id: step.dataset.blockId };
        this.dispatchEvent(new CustomEvent('tcc:listicle:step', { bubbles: true, detail: detail }));
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({ event: 'tcc_listicle_step', tcc_listicle: detail });
        }
      }

      /* ---------- Events ---------- */
      onClick(e) {
        const t = e.target instanceof Element ? e.target.closest('[data-next],[data-prev],[data-add]') : null;
        if (!t || t.disabled) return;
        if (t.hasAttribute('data-next')) this.next();
        else if (t.hasAttribute('data-prev')) this.prev();
        else this.add(t);
      }

      onChange(e) {
        const sel = e.target instanceof Element ? e.target.closest('[data-variant-select]') : null;
        if (!sel) return;
        const o = sel.selectedOptions[0];
        const offer = sel.closest('[data-offer]');
        if (!o || !offer) return;
        const set = (q, val) => {
          const el = offer.querySelector(q);
          if (!el) return;
          el.textContent = val || '';
          el.hidden = !val;
        };
        set('[data-price]', o.dataset.price);
        set('[data-compare]', o.dataset.compare);
        set('[data-save]', o.dataset.save);
      }

      /* ---------- Cart ---------- */
      async add(btn) {
        const step = btn.closest('[data-step]');
        let id = btn.dataset.variant;
        if (btn.hasAttribute('data-use-select') && step) {
          const sel = step.querySelector('[data-variant-select]');
          if (sel && sel.value) id = sel.value;
        }
        if (!id) return;
        const scope = btn.closest('[data-offer]') || btn.closest('[data-bar]') || step;
        const err = (scope && scope.querySelector('[data-error]')) || (step && step.querySelector('[data-error]'));
        btn.disabled = true;
        btn.classList.add('is-loading');
        if (err) err.hidden = true;
        try {
          const r = await fetch(this.dataset.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          });
          if (!r.ok) throw new Error('add');
          const root = (this.dataset.root || '/').replace(/\/$/, '');
          let target = btn.dataset.action === 'checkout' ? root + '/checkout' : this.dataset.cartUrl;
          const code = step ? (step.dataset.discount || '').trim() : '';
          if (code) target = root + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target);
          window.location.href = target;
        } catch (e) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          if (err) err.hidden = false;
          this.dock();
        }
      }

      /* ---------- Date + timer ---------- */
      initDates() {
        const lang = document.documentElement.lang || undefined;
        let today = '';
        try { today = new Date().toLocaleDateString(lang, { year: 'numeric', month: 'long', day: 'numeric' }); } catch (err) { return; }
        this.querySelectorAll('[data-date]').forEach((el) => {
          el.textContent = el.dataset.date.replace(/\{today\}/g, today);
        });
      }

      initTimer() {
        const els = Array.from(this.querySelectorAll('[data-timer-value]'));
        if (!els.length) return;
        const dur = Math.max(1, parseFloat(this.dataset.timerMinutes) || 15) * 60000;
        const restart = this.dataset.timerRestart === 'true';
        const key = 'tcc-listicle-timer-' + this.id_;
        const save = (v) => { try { sessionStorage.setItem(key, String(v)); } catch (err) {} };
        let end = 0;
        try { end = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (err) {}
        if (!end || (end <= Date.now() && restart)) { end = Date.now() + dur; save(end); }
        const two = (n) => String(n).padStart(2, '0');
        const tick = () => {
          let left = end - Date.now();
          if (left <= 0) {
            if (restart) { end = Date.now() + dur; save(end); left = dur; }
            else left = 0;
          }
          const sec = Math.ceil(left / 1000);
          const h = Math.floor(sec / 3600);
          const m = Math.floor((sec % 3600) / 60);
          const sc = sec % 60;
          const txt = two(h) + ':' + two(m) + ':' + two(sc);
          els.forEach((el) => { el.textContent = txt; });
          if (!left && this.timerId) clearInterval(this.timerId);
        };
        tick();
        this.timerId = setInterval(tick, 1000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-interactive-vertical"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcc-vertical')) {
    customElements.define('tcc-vertical', class TccVertical extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.id_ = this.dataset.sectionId;
        this.design = this.dataset.design === 'true';
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.picked = '';

        this._onClick = this.onClick.bind(this);
        this._onChange = this.onChange.bind(this);
        this._onInput = this.onInput.bind(this);
        this._onShow = () => {
          this.querySelectorAll('.is-loading').forEach((b) => { b.classList.remove('is-loading'); b.disabled = false; });
          this.unlockIfIdle();
        };
        this.addEventListener('click', this._onClick);
        this.addEventListener('change', this._onChange);
        this.addEventListener('input', this._onInput);
        window.addEventListener('pageshow', this._onShow);

        this.initDates();
        this.initSigns();
        this.initTimer();
        this.initDrawers();
        this.lightbox = this.querySelector('[data-lightbox]');
        if (this.lightbox) {
          this.lightbox.addEventListener('cancel', (e) => { e.preventDefault(); this.lightboxClose(); });
          this.lightbox.addEventListener('click', (e) => { if (e.target === this.lightbox) this.lightboxClose(); });
        }
        this.initScrollGuard();
        this.initBar();
        this.querySelectorAll('[data-revs]').forEach((w) => {
          const t = w.querySelector('[data-rev-track]');
          if (t) t.addEventListener('scroll', () => this.revArrows(w), { passive: true });
          this.revArrows(w);
        });

        if (this.design) {
          const pv = this.querySelector('[data-drawer][data-preview]');
          if (pv) this.openDrawer(pv);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('change', this._onChange);
        this.removeEventListener('input', this._onInput);
        window.removeEventListener('pageshow', this._onShow);
        if (this._onBarScroll) {
          window.removeEventListener('scroll', this._onBarScroll);
          window.removeEventListener('resize', this._onBarScroll);
        }
        if (this._barRaf) cancelAnimationFrame(this._barRaf);
        if (this._io) this._io.disconnect();
        if (this.timerId) clearInterval(this.timerId);
        if (this._sgMo) this._sgMo.disconnect();
        if (this._sgRaf) cancelAnimationFrame(this._sgRaf);
        this._sgRaf = null;
        (this.drawers || []).forEach((d) => { try { if (d.open) d.close(); } catch (err) {} });
        if (this.lightbox && this.lightbox.open) { try { this.lightbox.close(); } catch (err) {} }
        document.documentElement.classList.remove('tcc-vertical-lock', 'tcc-vertical-unlock');
        this._ready = false;
      }

      /* ---------- Events ---------- */
      onClick(e) {
        if (e.target instanceof Element && e.target.closest('[data-pi-card],[data-pi-switch],[data-pi-mode]') && this.piClick(e.target)) return;
        const t = e.target instanceof Element
          ? e.target.closest('[data-add],[data-drag-card],[data-rev],[data-drawer-open],[data-drawer-go],[data-drawer-close],[data-scroll-next],[data-scroll-offer],[data-lightbox-open],[data-lightbox-close]')
          : null;
        if (!t || t.disabled) return;
        if (t.hasAttribute('data-drag-card')) this.dragCard(t);
        else if (t.hasAttribute('data-rev')) this.revMove(t);
        else if (t.hasAttribute('data-drawer-open')) {
          const step = t.closest('[data-step]');
          const dr = step ? step.querySelector('[data-drawer]') : null;
          if (dr) { this._opener = t; this.openDrawer(dr); }
        } else if (t.hasAttribute('data-drawer-go')) this.drawerGo(t);
        else if (t.hasAttribute('data-drawer-close')) this.closeDrawer(t.closest('[data-drawer]'));
        else if (t.hasAttribute('data-scroll-next')) this.scrollNext(t);
        else if (t.hasAttribute('data-scroll-offer')) this.scrollOffer();
        else if (t.hasAttribute('data-lightbox-open')) this.lightboxOpen(t);
        else if (t.hasAttribute('data-lightbox-close')) this.lightboxClose();
        else this.add(t);
      }

      /* ---------- Scrolling between blocks ---------- */
      stickyOffset() {
        const a = this.querySelector('[data-announce]');
        let h = 0;
        if (a && getComputedStyle(a).position === 'sticky') h += a.offsetHeight + (parseFloat(getComputedStyle(a).top) || 0);
        return h;
      }

      scrollToEl(el) {
        if (!el) return;
        const top = el.getBoundingClientRect().top + window.scrollY - this.stickyOffset() - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: this.reduced() ? 'auto' : 'smooth' });
      }

      scrollNext(btn) {
        const step = btn.closest('[data-step]');
        const i = this.steps.indexOf(step);
        this.scrollToEl(this.steps[i + 1]);
      }

      offerTarget() {
        return this.querySelector('[data-fin]') || this.querySelector('[data-step][data-type="final"]') || this.querySelector('[data-offer]');
      }

      scrollOffer() { this.scrollToEl(this.offerTarget()); }

      /* Open the offer drawer from anywhere on the page; scroll to the offer when there is no drawer */
      drawerGo(btn) {
        const dr = this.querySelector('[data-drawer]');
        if (!dr) { this.scrollOffer(); return; }
        this._opener = btn;
        this.openDrawer(dr);
        this.barUpdate();
      }

      /* ---------- Sticky CTA bar ---------- */
      initBar() {
        this.bar = this.querySelector('[data-vbar]');
        if (!this.bar || this.bar.hasAttribute('data-preview')) return;
        this._offerOn = false;
        const targets = Array.from(this.querySelectorAll('[data-fin], [data-offer]'));
        if (this.bar.dataset.hideOffer === 'true' && targets.length && window.IntersectionObserver) {
          this._io = new IntersectionObserver((entries) => {
            entries.forEach((en) => { en.target._tccVis = en.isIntersecting; });
            this._offerOn = targets.some((el) => el._tccVis);
            this.barUpdate();
          }, { threshold: 0.2 });
          targets.forEach((el) => this._io.observe(el));
        }
        this._trig = this.bar.dataset.trigger || 'scroll';
        this._trigEl = this.barTriggerEl();
        this._onBarScroll = () => {
          if (this._barRaf) return;
          this._barRaf = requestAnimationFrame(() => { this._barRaf = null; this.barUpdate(); });
        };
        window.addEventListener('scroll', this._onBarScroll, { passive: true });
        window.addEventListener('resize', this._onBarScroll);
        this.barUpdate();
      }

      /* Element the bar waits for: a block of this listicle, or any element on the page by CSS selector */
      barTriggerEl() {
        const bar = this.bar;
        if (!bar) return null;
        if (this._trig === 'block') {
          const n = parseInt(bar.dataset.afterBlock, 10) || 0;
          return n > 0 ? (this.steps[Math.min(n, this.steps.length) - 1] || null) : null;
        }
        if (this._trig === 'selector') {
          const sel = (bar.dataset.afterSelector || '').trim();
          if (!sel) return null;
          try { return document.querySelector(sel); } catch (err) { return null; }
        }
        return null;
      }

      barUpdate() {
        const bar = this.bar;
        if (!bar || bar.hasAttribute('data-preview')) return;
        const r = this.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const after = parseFloat(bar.dataset.after) || 0;
        const drawerOpen = (this.drawers || []).some((d) => d.open);
        if (this._trig !== 'scroll' && (!this._trigEl || !this._trigEl.isConnected)) this._trigEl = this.barTriggerEl();
        let passed;
        if (this._trigEl) {
          const tr = this._trigEl.getBoundingClientRect();
          passed = (bar.dataset.afterPoint === 'bottom' ? tr.bottom : tr.top) <= 0;
        } else {
          passed = -r.top >= after;
        }
        const show = passed && r.bottom > vh && !this._offerOn && !drawerOpen;
        if (bar.classList.contains('is-visible') === show) return;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.inert = !show;
      }

      onChange(e) {
        if (!(e.target instanceof Element)) return;
        if (e.target.matches('[data-sign-check]')) { this.signUpdate(true); return; }
        const sel = e.target.closest('[data-variant-select]');
        if (!sel) return;
        const o = sel.selectedOptions[0];
        const offer = sel.closest('[data-offer]');
        if (!o || !offer) return;
        const set = (q, val) => {
          const el = offer.querySelector(q);
          if (!el) return;
          el.textContent = val || '';
          el.hidden = !val;
        };
        set('[data-price]', o.dataset.price);
        set('[data-compare]', o.dataset.compare);
        set('[data-save]', o.dataset.save);
      }

      onInput(e) {
        const r = e.target instanceof Element ? e.target.closest('[data-drag-range]') : null;
        if (r) this.dragSet(r.closest('[data-drag]'), Number(r.value), true);
      }

      dragSet(drag, val, user) {
        if (!drag) return;
        const range = drag.querySelector('[data-drag-range]');
        if (!range) return;
        const min = Number(range.min) || 0;
        const max = Number(range.max) || 0;
        val = Math.min(Math.max(Math.round(val), min), max);
        range.value = val;
        range.style.setProperty('--p', (max > min ? ((val - min) / (max - min)) * 100 : 0) + '%');
        const unit = drag.dataset.unit || '';
        range.setAttribute('aria-valuetext', val + unit);
        const out = drag.querySelector('[data-drag-value]');
        if (out) out.textContent = val + unit;

        const cards = Array.from(drag.querySelectorAll('[data-drag-card]'));
        const card = cards.find((c) => c.dataset.max === '' || val <= Number(c.dataset.max)) || cards[cards.length - 1];
        cards.forEach((c) => {
          const on = c === card;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (!card) return;
        const n = parseInt(card.dataset.amount, 10) || 0;
        const per = Math.max(1, parseFloat(drag.dataset.per) || 1);
        const icons = Math.min(20, Math.ceil(n / per));
        drag.querySelectorAll('[data-drag-icon]').forEach((ic, k) => { ic.hidden = k >= icons; });
        const amt = drag.querySelector('[data-drag-amount]');
        if (amt) amt.textContent = n + ' ' + (n === 1 ? drag.dataset.one : drag.dataset.many);
        if (user) this.picked = card.dataset.name || '';
      }

      dragCard(card) {
        const drag = card.closest('[data-drag]');
        if (!drag) return;
        const range = drag.querySelector('[data-drag-range]');
        const cards = Array.from(drag.querySelectorAll('[data-drag-card]'));
        const k = cards.indexOf(card);
        let val;
        if (card.dataset.max !== '') val = Number(card.dataset.max);
        else if (k > 0 && cards[k - 1].dataset.max !== '') val = Number(cards[k - 1].dataset.max) + 1;
        else val = range ? Number(range.max) : 0;
        this.dragSet(drag, val, true);
      }

      revMove(btn) {
        const wrap = btn.closest('[data-revs]');
        const track = wrap ? wrap.querySelector('[data-rev-track]') : null;
        if (!track) return;
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        track.scrollBy({ left: step * Number(btn.dataset.rev), behavior: this.reduced() ? 'auto' : 'smooth' });
      }

      revArrows(wrap) {
        if (!wrap) return;
        const track = wrap.querySelector('[data-rev-track]');
        const arrows = wrap.querySelector('[data-rev-arrows]');
        if (!track || !arrows) return;
        const max = track.scrollWidth - track.clientWidth;
        arrows.hidden = max <= 2;
        const [prev, next] = arrows.querySelectorAll('[data-rev]');
        const x = Math.abs(track.scrollLeft);
        if (prev) prev.disabled = x <= 2;
        if (next) next.disabled = x >= max - 2;
      }

      initDrawers() {
        this.drawers = Array.from(this.querySelectorAll('[data-drawer]'));
        this.drawers.forEach((d) => {
          d.addEventListener('cancel', (e) => { e.preventDefault(); this.closeDrawer(d); });
          d.addEventListener('click', (e) => { if (e.target === d) this.closeDrawer(d); });
          const cards = Array.from(d.querySelectorAll('[data-pi-card]'));
          const act = cards.findIndex((c) => c.classList.contains('is-active'));
          d._i = act > -1 ? act : 0;
          d._wantSub = d.dataset.defaultSub === 'true';
          this.piRender(d);
        });
      }

      piClick(t) {
        const dr = t.closest('[data-drawer]');
        if (!dr) return false;
        const card = t.closest('[data-pi-card]');
        if (card) {
          if (card.disabled) return true;
          dr._i = Array.from(dr.querySelectorAll('[data-pi-card]')).indexOf(card);
          this.piRender(dr);
          return true;
        }
        const sw = dr.querySelector('[data-pi-switch]');
        const canToggle = sw && !sw.disabled;
        if (t.closest('[data-pi-switch]')) {
          if (canToggle) { dr._wantSub = !dr._sub; this.piRender(dr); }
          return true;
        }
        const mode = t.closest('[data-pi-mode]');
        if (mode) {
          if (canToggle) { dr._wantSub = mode.dataset.piMode === 'sub'; this.piRender(dr); }
          return true;
        }
        return false;
      }

      piRender(dr) {
        const cards = Array.from(dr.querySelectorAll('[data-pi-card]'));
        const i = dr._i || 0;
        cards.forEach((c, k) => {
          const on = k === i;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        dr.querySelectorAll('[data-pi-panel]').forEach((p) => { p.hidden = Number(p.dataset.piPanel) !== i; });

        const card = cards[i];
        const atc = dr.querySelector('[data-drawer-atc]');
        if (!card) {
          /* Single product without size cards: keep the server-rendered state, only sync the toggle */
          this.piMode(dr, dr.dataset.plan || '', atc);
          return;
        }
        const plan = card.dataset.planId || '';
        this.piMode(dr, plan, atc);
        dr.querySelectorAll('[data-pi-percent]').forEach((el) => { el.textContent = card.dataset.percent || '0'; });
        dr.querySelectorAll('[data-pi-after-percent]').forEach((el) => { el.textContent = card.dataset.afterPercent || '0'; });
        if (atc) {
          const ok = !!card.dataset.variantId && card.dataset.available === 'true';
          atc.dataset.variant = ok ? card.dataset.variantId : '';
          atc.disabled = !ok;
          atc.dataset.plan = dr._sub ? plan : '';
        }
        const err = dr.querySelector('[data-error]');
        if (err) err.hidden = true;
      }

      piMode(dr, plan, atc) {
        const hasPlan = plan !== '';
        const requires = dr.dataset.requiresPlan === 'true';
        dr._sub = hasPlan && (requires || dr._wantSub);
        dr.classList.toggle('tcc-vertical__pi--sub', dr._sub);
        dr.classList.toggle('tcc-vertical__pi--once', !dr._sub);
        dr.classList.toggle('tcc-vertical__pi--no-plan', !hasPlan);
        const sw = dr.querySelector('[data-pi-switch]');
        if (sw) {
          sw.setAttribute('aria-checked', String(dr._sub));
          sw.disabled = !hasPlan || requires;
        }
        if (atc) atc.dataset.plan = dr._sub ? plan : '';
      }

      piPick(dr, name) {
        const want = String(name || '').trim().toLowerCase();
        if (!want) return;
        const cards = Array.from(dr.querySelectorAll('[data-pi-card]'));
        const k = cards.findIndex((c) => {
          const n = (c.dataset.name || '').trim().toLowerCase();
          return n === want || n.indexOf(want + ' ') === 0 || want.indexOf(n + ' ') === 0;
        });
        if (k > -1 && !cards[k].disabled) { dr._i = k; this.piRender(dr); }
      }

      openDrawer(dr) {
        if (!dr || dr.open) return;
        if (this.picked && dr._picked !== this.picked) {
          dr._picked = this.picked;
          this.piPick(dr, this.picked);
        }
        this._lastFocus = this._opener || document.activeElement;
        this._opener = null;
        try { dr.showModal(); } catch (err) { dr.setAttribute('open', ''); }
        document.documentElement.classList.add('tcc-vertical-lock');
        requestAnimationFrame(() => requestAnimationFrame(() => dr.classList.add('is-open')));
        if (this.bar) this.barUpdate();
        if (!this.design) this.dispatchEvent(new CustomEvent('tcc:vertical:drawer', { bubbles: true, detail: { section: this.id_, open: true } }));
      }

      closeDrawer(dr, instant) {
        if (!dr || !dr.open) return;
        dr.classList.remove('is-open');
        const done = () => {
          try { dr.close(); } catch (err) { dr.removeAttribute('open'); }
          if (!(this.drawers || []).some((d) => d.open)) document.documentElement.classList.remove('tcc-vertical-lock');
          const f = this._lastFocus;
          this._lastFocus = null;
          if (!instant && f && typeof f.focus === 'function' && this.contains(f)) f.focus({ preventScroll: true });
          this.barUpdate();
        };
        if (instant || this.reduced()) done();
        else setTimeout(done, 320);
      }

      async add(btn) {
        const step = btn.closest('[data-step]');
        let id = btn.dataset.variant;
        if (btn.hasAttribute('data-use-select') && step) {
          const sel = step.querySelector('[data-variant-select]');
          if (sel && sel.value) id = sel.value;
        }
        if (!id) return;
        const scope = btn.closest('[data-drawer]') || btn.closest('[data-offer]') || btn.parentElement || step;
        const err = (scope && scope.querySelector('[data-error]')) || (step && step.querySelector('[data-error]'));
        btn.disabled = true;
        btn.classList.add('is-loading');
        if (err) err.hidden = true;
        try {
          const r = await fetch(this.dataset.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [(() => {
              const it = { id: Number(id), quantity: 1 };
              if (btn.dataset.plan) it.selling_plan = Number(btn.dataset.plan);
              return it;
            })()] })
          });
          if (!r.ok) throw new Error('add');
          const root = (this.dataset.root || '/').replace(/\/$/, '');
          let target = btn.dataset.action === 'checkout' ? root + '/checkout' : this.dataset.cartUrl;
          const code = step ? (step.dataset.discount || '').trim() : '';
          if (code) target = root + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target);
          window.location.href = target;
        } catch (e) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          if (err) err.hidden = false;
        }
      }

      initDates() {
        const lang = document.documentElement.lang || undefined;
        let today = '';
        try { today = new Date().toLocaleDateString(lang, { year: 'numeric', month: 'long', day: 'numeric' }); } catch (err) { return; }
        this.querySelectorAll('[data-date]').forEach((el) => {
          el.textContent = el.dataset.date.replace(/\{today\}/g, today);
        });
      }

      initTimer() {
        const els = Array.from(this.querySelectorAll('[data-timer-value]'));
        if (!els.length) return;
        const dur = Math.max(1, parseFloat(this.dataset.timerMinutes) || 15) * 60000;
        const restart = this.dataset.timerRestart === 'true';
        const key = 'tcc-vertical-timer-' + this.id_;
        const save = (v) => { try { sessionStorage.setItem(key, String(v)); } catch (err) {} };
        let end = 0;
        try { end = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (err) {}
        if (!end || (end <= Date.now() && restart)) { end = Date.now() + dur; save(end); }
        const two = (n) => String(n).padStart(2, '0');
        const tick = () => {
          let left = end - Date.now();
          if (left <= 0) {
            if (restart) { end = Date.now() + dur; save(end); left = dur; }
            else left = 0;
          }
          const sec = Math.ceil(left / 1000);
          const h = Math.floor(sec / 3600);
          const m = Math.floor((sec % 3600) / 60);
          const sc = sec % 60;
          const txt = two(h) + ':' + two(m) + ':' + two(sc);
          const lbl = two(h) + 'h : ' + two(m) + 'm : ' + two(sc) + 's';
          els.forEach((el) => { el.textContent = el.dataset.format === 'labels' ? lbl : txt; });
          if (!left && this.timerId) clearInterval(this.timerId);
        };
        tick();
        this.timerId = setInterval(tick, 1000);
      }

      lightboxOpen(btn) {
        const lb = this.lightbox;
        if (!lb || lb.open) return;
        const img = lb.querySelector('[data-lightbox-img]');
        if (img) {
          if (btn.dataset.w) img.width = Number(btn.dataset.w);
          if (btn.dataset.h) img.height = Number(btn.dataset.h);
          img.src = btn.dataset.src || '';
          img.alt = btn.dataset.alt || '';
        }
        this._lbFocus = btn;
        try { lb.showModal(); } catch (err) { lb.setAttribute('open', ''); }
        document.documentElement.classList.add('tcc-vertical-lock');
      }

      lightboxClose() {
        const lb = this.lightbox;
        if (!lb || !lb.open) return;
        try { lb.close(); } catch (err) { lb.removeAttribute('open'); }
        if (!(this.drawers || []).some((d) => d.open)) document.documentElement.classList.remove('tcc-vertical-lock');
        const img = lb.querySelector('[data-lightbox-img]');
        if (img) img.src = 'data:,';
        if (this._lbFocus && this.contains(this._lbFocus)) this._lbFocus.focus({ preventScroll: true });
        this._lbFocus = null;
      }

      initScrollGuard() {
        if (!window.MutationObserver || !document.body) return;
        this._sgCheck = () => {
          if (this._sgRaf) return;
          this._sgRaf = requestAnimationFrame(() => { this._sgRaf = null; this.scrollGuard(); });
        };
        this._sgMo = new MutationObserver(this._sgCheck);
        const opts = { attributes: true, attributeFilter: ['class', 'style'] };
        this._sgMo.observe(document.documentElement, opts);
        this._sgMo.observe(document.body, opts);
        this._sgCheck();
      }

      scrollGuard() {
        const html = document.documentElement;
        const body = document.body;
        if (!body) return;
        const unlocked = html.classList.contains('tcc-vertical-unlock');
        if (this.modalOnScreen()) {
          if (unlocked) html.classList.remove('tcc-vertical-unlock');
          return;
        }
        if (unlocked) return;
        const hs = getComputedStyle(html);
        const bs = getComputedStyle(body);
        const locked = hs.overflowY === 'hidden' || hs.overflowY === 'clip' || bs.overflowY === 'hidden' || bs.overflowY === 'clip' ||
          bs.position === 'fixed' || hs.touchAction === 'none' || bs.touchAction === 'none';
        if (locked) html.classList.add('tcc-vertical-unlock');
      }

      modalOnScreen() {
        if ((this.drawers || []).some((d) => d.open) || (this.lightbox && this.lightbox.open)) return true;
        const vw = window.innerWidth || 0;
        const vh = window.innerHeight || 0;
        return Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"]')).some((el) => {
          if (this.contains(el)) return false;
          const r = el.getBoundingClientRect();
          if (r.width < 2 || r.height < 2 || r.right <= 0 || r.bottom <= 0 || r.left >= vw || r.top >= vh) return false;
          const cs = getComputedStyle(el);
          return cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity) > 0.05;
        });
      }

      unlockIfIdle() {
        const anyOpen = (this.drawers || []).some((d) => d.open) || (this.lightbox && this.lightbox.open);
        if (!anyOpen) document.documentElement.classList.remove('tcc-vertical-lock');
      }

      /* ---------- Signs checklist + result ---------- */
      initSigns() {
        this.signChecks = Array.from(this.querySelectorAll('[data-sign-check]'));
        this.signResults = Array.from(this.querySelectorAll('[data-sign-result]'));
        if (!this.signChecks.length && !this.signResults.length) return;
        this._signKey = 'tcc-vertical-signs-' + this.id_;
        let saved = [];
        try { saved = JSON.parse(sessionStorage.getItem(this._signKey) || '[]'); } catch (err) {}
        if (Array.isArray(saved) && saved.length) {
          this.signChecks.forEach((c) => { if (saved.indexOf(c.dataset.signId) > -1) c.checked = true; });
        }
        this.signUpdate(false);
      }

      signUpdate(save) {
        const checks = this.signChecks || [];
        const on = checks.filter((c) => c.checked);
        const count = on.length;
        checks.forEach((c) => {
          const row = c.closest('[data-sign-row]');
          if (row) row.classList.toggle('is-checked', c.checked);
        });
        if (save && this._signKey) {
          try { sessionStorage.setItem(this._signKey, JSON.stringify(on.map((c) => c.dataset.signId))); } catch (err) {}
        }
        (this.signResults || []).forEach((r) => {
          r.querySelectorAll('[data-sign-count]').forEach((el) => { el.textContent = count; });
          r.querySelectorAll('[data-sign-dot]').forEach((d, k) => { d.classList.toggle('is-on', k < count); });
          const vs = Array.from(r.querySelectorAll('[data-sres-v]'));
          const min = (v) => parseInt(v.dataset.min, 10) || 0;
          let pick = null;
          let low = null;
          vs.forEach((v) => {
            if (min(v) <= count && (!pick || min(v) >= min(pick))) pick = v;
            if (!low || min(v) < min(low)) low = v;
          });
          pick = pick || low;
          vs.forEach((v) => { v.hidden = v !== pick; });
          if (r.dataset.hideEmpty === 'true' && !this.design) {
            const step = r.closest('[data-step]');
            if (step) step.hidden = count === 0;
          }
        });
      }

      reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
